import { Info } from 'lucide-react';

// import './EEmpty.scss';

type Props = {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  button?: JSX.Element;
};

export function EEmpty({ title, description, icon, button }: Props) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-gray-500">
      {icon ? icon : <Info size={48} />}
      <span className={`text-lg font-medium ${icon ? 'mt-4' : ''}`}>{title}</span>
      <span className="text-sm text-gray-400">{description}</span>
      {button ? <div className="mt-6">{button}</div> : null}
    </div>
  );
}
